









































































	import { BaseTLTableComponent, AxiosResponse, Component, PersonCommunicationService, PersonCommunicationFilter, Prop } from "../../../Infrastructure/CorBase/CoreBase";


	@Component
	export default class ContactList extends BaseTLTableComponent {
		@Prop({ type: Boolean, required: false, default: false }) isUpdate?: boolean;

		idPerson: number = 0;
	
		contact: string = '';
		idTypeContact: number = 0;
		itemsTypeExist: number[] = []; //které už má
		updateMode: boolean = false;

		labelWidth: string = "1";
		inputWidth: string = "6";

		onlyShow: boolean = false;

		personCommunicationService: PersonCommunicationService = new PersonCommunicationService();

		isMail() {
			if (this.enums.length > 0 && this.idTypeContact > 0) {
				if ((this.enums.filter(c => c.id == this.idTypeContact)[0]).identifier == 'ENU_COR_CommunicationMedium_MediumType_Email') {
					return true;
				}
			}
			return false;
		}


		label() {
			if (this.isMail()) {
				return "Email";
			}
			else {
				return "Telefon"
			}
		}

		maxLength() {
			if (this.isMail()) {
				return "50";
			}
			else {
				return "16"
			}
		}

		typeValidation() {
			if (this.isMail()) {
				return "email";
			}
			else {
				return "phone"
			}
		}

		setPersonId(id: number) {
			this.idPerson = id;
			this.fetchData();
		}

		allowNot: boolean = false;
		_correct: boolean = false;
		isCorrect(value: any) {
			this.allowNot = !this._correct;
			this._correct = value;

		}

		notAllowAdd() {
			return this._correct == false;
		}


		notAllowNewContact() {
			return !this._correct;
		}

		showCreateButton() {			
			return this.tableData.filter(c => c.idEnuTypeNavigation == this.idTypeContact).length == 0 && this.idTypeContact != 0;
		
		}

		isNewContact() {
			return true;
		}

		formCommData = {
			idPerson: 0,
			idCommunicationMedium: 0,
			idEnuTypeNavigation: 0,
			identificator: '',
			isMain: false,
			delete: false,
			idTenant: this.$store.state.idTenant
		}



		createContact() {
			this.formCommData.idPerson = this.idPerson;
			this.formCommData.identificator = this.contact;
			this.formCommData.idEnuTypeNavigation = this.idTypeContact;
			this.formCommData.isMain = false;

			this.personCommunicationService.create(this.formCommData).then(() => {
			}).then(() => {
				this.fetchData();
			}
			).catch((error) => {
			});
		}

		enums: any[] = [];

		created() {			
			super.initializeRights('COR_Person_Create', 'COR_Person_Delete', 'COR_Person_Read', 'COR_Person_Update');
			super.created();
			this.idPerson = this.objectIdFromParam;

			this.fetchData();
		};


		setFields() {
			this.fields = [
				{ key: 'idEnuTypeNavigationName', label: 'Druh kontaktu', sortable: true, class: 'text-center' },
				{ key: 'idCommunicationMediumNavigationIdentificator', label: 'Popis', sortable: true, class: 'text-center' },
				{ key: 'actions', label: 'Volby' , class: 'text-right'}
			]
		};

		//filtry
		setfilters(value: any) {
		}

		
		loadFilters(value: any) { super.loadFilters(value); };
		createNewClick(elementId: any) { this.createContact(); }
	
		deleteClick(elementId: any) { this.deleteContact(elementId); }

		fetchDataFromServer(): Promise<AxiosResponse<any>> {
			
			let personCommunicationFilter: PersonCommunicationFilter = new PersonCommunicationFilter(this.idPerson, null);		
			return this.personCommunicationService.getAllByFilter(personCommunicationFilter);
		}

        //zatím nepotrebujeme
        fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
            return this.fetchDataFromServer();
        }

        refreshItems(items: any[], refreshData: any[]) {
            return items;
        }

		fetchData() {
			if (this.idPerson > 0) {
				super.fetchData();
				this.goBack();
			}

		}

		prepareItems(items: any[]) {		
			for (var i = 0; i < items.length; i++) {
				items[i].id = items[i].idCommunicationMedium;			
			}
		}

		updateContact() {		
			this.formCommData.idPerson = this.idPerson;		
			this.formCommData.identificator = this.contact;
			this.formCommData.idEnuTypeNavigation = this.idTypeContact;
		
			this.personCommunicationService.update(this.formCommData.idPerson, this.formCommData).then(() => {
			}).then(() => {
			
				this.fetchData();
			}
			).catch((error) => {
				
			})
		}

		goBack() {
			this.updateMode = false;
			this.idTypeContact = 0;
			this.contact = '';
		}

		startUpdate(id: any) {
			this.formCommData.idCommunicationMedium = id;
			this.contact = this.tableData.filter(c => c.id == id)[0].idCommunicationMediumNavigationIdentificator;
			this.idTypeContact = Number(this.tableData.filter(c => c.id == id)[0].idEnuTypeNavigation);
			this.updateMode = true;
		}

		deleteContact(id: any) {
			this.formCommData.idPerson = this.idPerson;
			this.formCommData.idCommunicationMedium = this.tableData.filter(c => c.id == id)[0].idCommunicationMedium;
			this.formCommData.delete = true;
			this.personCommunicationService.update(this.formCommData.idCommunicationMedium, this.formCommData).then(() => {

				this.fetchData();
			}).catch((error) => {
			})
		};




	};
